// src/store/thunks/sixCatalog/toggleFavoriteSixThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { fetchSixCatalogThunk } from '@/store/thunks/sixCatalog/fetchSixCatalog';
import type { SixFavoriteDTO } from '@/types/SixCatalogDTOs';
import { withErrorHandling, withLoader } from "@/store/thunks/thunkWrappers";

export const toggleFavoriteSixThunk = createAppAsyncThunk<SixFavoriteDTO, string>(
  'sixCatalog/toggleFavoriteSix',
    withLoader(
      withErrorHandling(
  async(sixId, { extra, dispatch }) => {
    const result = await extra.sixCatalogService.toggleFavoriteSix(sixId);
    await dispatch(fetchSixCatalogThunk()).unwrap();
    return result;
  }))
);
